"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledSpinnerContainer = exports.StyledButtonLabel = exports.StyledButton = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var getThemeNode = function getThemeNode(props) {
  var color = props.color,
      disabled = props.disabled,
      outline = props.outline;
  var themeNode;

  if (disabled) {
    themeNode = outline ? props.theme.button.disabled.outline : props.theme.button.disabled;
  } else {
    themeNode = outline ? props.theme.button[color].outline : props.theme.button[color];
  }

  return themeNode;
};

var StyledSpinnerContainer = _styledComponents["default"].div.withConfig({
  displayName: "Buttonstyles__StyledSpinnerContainer",
  componentId: "sc-ghq141-0"
})(["", ""], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["w1 mr1 nl1 relative"]))));

exports.StyledSpinnerContainer = StyledSpinnerContainer;

var StyledButton = _styledComponents["default"].button.withConfig({
  displayName: "Buttonstyles__StyledButton",
  componentId: "sc-ghq141-1"
})(["", " text-decoration:none;transition:all 0.2s ease;cursor:", ";", " &:disabled{cursor:not-allowed;", "}&[data-loading='false']:not(:disabled){&:before{content:'';position:absolute;top:-1px;left:-1px;right:-1px;bottom:-1px;border-radius:4px;transition:all 0.5s ease;}&:hover{text-decoration:none;", ";", "}}& > div{", "}& .button-appended-content,& .button-prepended-content{max-height:1rem;min-height:1rem;min-width:1rem;}"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    ba lh-solid fw7 relative dib\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), function (props) {
  return props.loading ? 'nowrap' : '';
}, function (props) {
  return props.theme.button.base;
}, function (_ref) {
  var hasChildren = _ref.hasChildren,
      size = _ref.size,
      sizes = _ref.theme.button.sizes;
  return hasChildren ? 'pa0 ma0' : sizes[size];
}, function (props) {
  var themeNode = getThemeNode(props);
  return "\n        ".concat(themeNode.appearance, " ").concat(themeNode.text, "\n      ");
}), function (_ref2) {
  var isLoading = _ref2.isLoading;
  return isLoading ? 'not-allowed;' : 'pointer';
}, function (props) {
  var themeNode = getThemeNode(props);
  return "\n      & svg circle {\n        stroke: var(--".concat(themeNode.text, ") !important;\n      }\n      ").concat(themeNode.overrides, "\n    ");
}, (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["\n      ", "\n    "])), function (_ref3) {
  var outline = _ref3.outline,
      disabled = _ref3.theme.button.disabled;
  var disabledObj = outline ? disabled.outline : disabled;
  return "\n          ".concat(disabledObj.appearance, " ").concat(disabledObj.text, "\n        ");
}), function (props) {
  return props.theme.button.scaleOnHover ? 'transform: scale(1.03)' : '';
}, function (_ref4) {
  var outline = _ref4.outline;
  return !outline && "\n        &:before {\n          background: ".concat(function (props) {
    return props.theme.button.hoverBackgroundColor;
  }, ";\n        }\n      ");
}, (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["flex items-center justify-center"]))));

exports.StyledButton = StyledButton;

var StyledButtonLabel = _styledComponents["default"].div.withConfig({
  displayName: "Buttonstyles__StyledButtonLabel",
  componentId: "sc-ghq141-2"
})(["", ""], (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["relative ph2"]))));

exports.StyledButtonLabel = StyledButtonLabel;